<script>
  import { Temporal } from "proposal-temporal";

  const { calendar } = new Intl.DateTimeFormat().resolvedOptions();

  export let date;
  export let relativeTo = Temporal.now.plainDate({ calendar });

  function until(plainDate) {
    const pdWithCalendar = plainDate.withCalendar(calendar);
    const u = relativeTo.until(pdWithCalendar, { relativeTo });
    return u.round({
      largestUnit: "month",
      smallestUnit: "day",
      relativeTo,
    });
  }

  const { months, days } = until(date);
</script>

<span>
  {#if months === 0 && days === 0}
    today
  {:else}
    {#if months > 1}
      {months} months
    {:else if months === 1}
      1 month
    {/if}
    {#if days > 1}
      {days} days
    {:else if days === 1}
      1 day
    {/if}
  {/if}
</span>

<style></style>
